export const PROFILE = {
  firstName: "Haseeb",
  lastName: "Sajjad",
  fullName: "Haseeb Sajjad",
  email: "haseebsajjadio670@gmail.com",
  phone: "+92 329 8689061",
  phoneLink: "+923298689061",
  whatsappUrl: "https://wa.me/923298689061",
  location: "Islamabad, Pakistan",
  github: "haseeb-io670",
  githubUrl: "https://github.com/haseeb-io670",
  linkedinUrl: "https://www.linkedin.com/in/haseeb-sajjad-379356323/",
  instagramUrl: "https://www.instagram.com/haseeb.cloud/",
  dateOfBirth: "04 November 2004",
  role: "Full Stack Developer",
};
